import * as amplitude from "@amplitude/analytics-browser";
import { alertTestAccountEvent } from "../analytics/testAccountAlert";
import { store } from "../../redux/store";
import { analyticsConfig } from "../../config/analytics.config";

export const trademoTrackingEvents = function (eventType, data) {
  const userData = store.getState().userDetails.userData;
  const email = userData.email;
  if (!email) return;
  const paidPlan = userData?.intelPaidPlans;
  const updatedData = { ...data, accessType: paidPlan?.length > 0 ? "Paid" : "Free" };
  alertTestAccountEvent(email, eventType, updatedData);
  if (import.meta.env.VITE_HOST_ENV && import.meta.env.VITE_HOST_ENV.toLowerCase() === "production") {
    window.pendo?.track(eventType, updatedData);
  }
  if (analyticsConfig.amplitude.enabled) {
    amplitude.track(eventType, updatedData);
  }
};
